import { Component, Input, OnInit } from '@angular/core';
import { ClosedMerchantCount } from '../../../../shared/models/EvoSalesPortalModel';
import { DashboardService } from '../../../../shared/services/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BindingContext } from '../../../../shared/models/BindingContext';
import { DashboardWidget } from '../../dashboard-interface';

@Component({
	selector: 'app-dashboard-closed',
	templateUrl: './dashboard-closed.component.html',
	styleUrls: ['./dashboard-closed.component.scss'],
	host: { 'class': 'col-md-6 col-lg-4' }
})
export class DashboardClosedComponent extends DashboardWidget implements OnInit {
	private debug = false;
	@Input() title: string;
	@Input() color: string;
	@Input() url: string;
	bindingContext: BindingContext = new BindingContext();
	public rawData: ClosedMerchantCount[];
	private dashboardError = 'Error loading dashboard item, please contact support.';
	constructor(private dashboardSvc: DashboardService) {
		super();
	}

	ngOnInit() {
		this.bindingContext.beginGet();
		this.getData();
	}

	private getData() {
		this.dashboardSvc.GetClosedMerchants().subscribe(
			(resp: ClosedMerchantCount[]) => {
				this.rawData = resp;
				if (this.debug) { console.log(this.rawData); }
				this.bindingContext.endGet();
			},
			(response: HttpErrorResponse) => {
				this.bindingContext.endGet();
				this.bindingContext.showAlert(BindingContext.alertType.danger, this.dashboardError, true);
			}
		);
	}
}
